<ng-container *ngIf="version == 'v1'">
  <ng-container *ngIf="riskNormalized !== 'unknown'">
    <div class="risk-meter {{riskNormalized}}">
      <img src="/assets/images/icon-meter-{{riskNormalized}}-white.svg" alt="Risk Meter Icon" />
      {{riskLabel}}
    </div>
  </ng-container>
  <ng-container [ngTemplateOutlet]="unknownRisk"></ng-container>
</ng-container>

<ng-container *ngIf="version == 'v2'">
  <ng-container *ngIf="riskNormalized !== 'unknown'">
    <div class="risk-meter v2">
      <img src="/assets/images/meters/{{riskNormalized}}-risk.svg" alt="Risk Meter Icon" />
      {{riskLabel}}
    </div>
  </ng-container>
  <ng-container [ngTemplateOutlet]="unknownRisk"></ng-container>
</ng-container>

<ng-container *ngIf="version == 'v3'">
  <ng-container *ngIf="riskNormalized !== 'unknown'">
    <div class="risk-meter v3 {{riskNormalized}}">
      <img src="/assets/images/meters/{{riskNormalized}}-risk.svg" alt="Risk Meter Icon" />
      {{riskLabel}}
    </div>
  </ng-container>
  <ng-container [ngTemplateOutlet]="unknownRisk"></ng-container>
</ng-container>

<ng-container *ngIf="version == 'v4'">
  <div class="risk-meter v4 {{riskNormalized}}">
    <ng-container *ngIf="riskNormalized !== 'unknown'">
      <img *ngIf="riskNormalized == 'critical'" width="14.5" height="18" src="/assets/icons/icon-risk-critical.svg"
        alt="Risk Meter Icon" />
      <svg *ngIf="riskNormalized !== 'critical'" xmlns="http://www.w3.org/2000/svg" width="9" height="9"
        viewBox="0 0 9 9" fill="none">
        <ellipse cx="4.22949" cy="4.22998" rx="4.22949" ry="4.22998" fill="currentColor" />
      </svg>
      {{riskLabel}}
    </ng-container>
    <ng-container [ngTemplateOutlet]="unknownRisk"></ng-container>
  </div>
</ng-container>

<ng-template #unknownRisk>
  <ng-container *ngIf="riskNormalized === 'unknown'">
    N/A
  </ng-container>
</ng-template>